
import Vuex from 'vuex';
import { caseAssignmentService } from '../services/caseAssignmentService';
import { taskService } from "@/services/task.service.js";
import { configService } from "@/services/config.service.js";
import validation from "./modules/validation.store";
import dailyTasks from "./modules/daily.tasks.store";
import allTasks from "./modules/all.tasks.store";
import study from './modules/study.store';
import tracks from './modules/tracks.store';
import assignment from './modules/assignment.store';
import map from './modules/map.store';
import staff from './modules/staff.store'
import { TASK_CONSTANTS } from "../common/task.constants";

import { createStore } from 'vuex'

// Create a new store instance.
const store = createStore({
  state () {
    return {
      uiTableConfigurations: [],
			page: ''
    }
  },
  mutations: {
    setUiTableConfigurations(state, { data }) {
			state.uiTableConfigurations = data;
		},
		setPage (state, page) {
			state.page = page
			// Vue.set(state, 'page', page);
		}
  },
	actions: {
		async loadUiTableConfigurations(context) {
			await configService.getConfigs().then(async function (response) {
				if (response && response.data) {
					context.commit('setUiTableConfigurations', { data: response.data });
				}
				return await Promise.resolve(1);
			}).catch(async function (e) {
				console.log(e);
				return await Promise.resolve(1);
			});
		},
		loadPage (context, page) {
			context.commit('setPage', page)
		},
		clearTablesData (context) {
			// using set function, sets the bottom allTasks table to empty array
			var empty = []
			context.commit('allTasks/setTasks', empty, { root: true });
			// calling existing clear staff daily info function
			context.commit('dailyTasks/clearStaffDailyInfo', { root: true }); // for the json call
		},
		clearStaffsDay (context) {
			// calling existing clear staff daily info function
			context.commit('dailyTasks/clearStaffDailyInfo', { root: true }); // for the json call
		}
	},
	getters: {
		uiTableConfigurations: (state) => {
			return state.uiTableConfigurations;
		},
		getPage: (state) => {
			return state.page;
		}
	},
	modules: {
		// survey: data,
		study: study,
		validation: validation,
		dailyTasks: dailyTasks,
		allTasks: allTasks,
		tracks: tracks,
		assignment: assignment,
		map: map,
		staff: staff
	}
})

export default store;

// Vue.use(Vuex);
// const data = {
// 	state: {
// 		uiTableConfigurations: [],
// 		page: ''
// 	},
// 	mutations: {
// 		setUiTableConfigurations(state, { data }) {
// 			state.uiTableConfigurations = data;
// 		},
// 		setPage (state, page) {
// 			Vue.set(state, 'page', page);
// 		}
// 	},
// 	actions: {
// 		async loadUiTableConfigurations(context) {
// 			await configService.getConfigs().then(async function (response) {
// 				if (response && response.data) {
// 					context.commit('setUiTableConfigurations', { data: response.data });
// 				}
// 				return await Promise.resolve(1);
// 			}).catch(async function (e) {
// 				console.log(e);
// 				return await Promise.resolve(1);
// 			});
// 		},
// 		loadPage (context, page) {
// 			context.commit('setPage', page)
// 		},
// 		clearTablesData (context) {
// 			// using set function, sets the bottom allTasks table to empty array
// 			var empty = []
// 			context.commit('allTasks/setTasks', empty, { root: true });
// 			// calling existing clear staff daily info function
// 			context.commit('dailyTasks/clearStaffDailyInfo', { root: true }); // for the json call
// 		},
// 		clearStaffsDay (context) {
// 			// calling existing clear staff daily info function
// 			context.commit('dailyTasks/clearStaffDailyInfo', { root: true }); // for the json call
// 		}
// 	},
// 	getters: {
// 		uiTableConfigurations: (state) => {
// 			return state.uiTableConfigurations;
// 		},
// 		getPage: (state) => {
// 			return state.page;
// 		}
// 	}
// };

// export default new Vuex.Store({
// 	modules: {
// 		survey: data,
// 		study: study,
// 		validation: validation,
// 		dailyTasks: dailyTasks,
// 		allTasks: allTasks,
// 		tracks: tracks,
// 		assignment: assignment
// 	}
// });
